import { Alert, Button, Flex } from '@utilitywarehouse/hearth-react';
import React from 'react';

import { DEFAULT_ERROR_MESSAGE } from '@constants/apiErrors';

interface ErrorComponentProps {
  message?: string;
}

export const DepositErrorComponent = ({
  message,
}: ErrorComponentProps): React.ReactElement => (
  <Flex direction="column" spacing="2xl" paddingTop="500">
    <Alert title="Error" colorScheme="danger">
      {message || DEFAULT_ERROR_MESSAGE}
    </Alert>
    <Flex justifyContent="end" direction={{ tablet: 'row', mobile: 'column' }}>
      <Button
        data-testid="deposit-error-button"
        onClick={() => window.location.replace(window.location.pathname)} // Needs to reload the deposit page with no query string parameters
        variant="solid"
      >
        Try again
      </Button>
    </Flex>
  </Flex>
);
